<template>
  <section v-if="items.length" id="experience-dna" class="dna-section">
    <v-container>
      <p class="section-kicker">Category Mix</p>
      <h2>Experience DNA</h2>
      <div class="dna-grid">
        <div v-for="item in displayItems" :key="item.id" class="dna-item">
          <div class="dna-heading">
            <span><v-icon v-if="item.icon" small>{{ item.icon }}</v-icon>{{ item.label }}</span>
            <strong>{{ item.score }}</strong>
          </div>
          <div class="dna-track"><i :style="{ width: `${normalized(item.score)}%` }"></i></div>
        </div>
      </div>
    </v-container>
  </section>
</template>

<script>
import { normalizeExperienceDNA } from '../../../data/reckon-way/experienceDNA';

export default {
  name: 'ExperienceDNA',
  props: {
    items: { type: Array, default: () => [] },
    includeConference: { type: Boolean, default: false },
  },
  computed: {
    displayItems() {
      return normalizeExperienceDNA(this.items, { includeConference: this.includeConference });
    },
  },
  methods: { normalized(score) { return Math.min(100, Math.max(0, Number(score) || 0)); } },
};
</script>

<style scoped>
.dna-section { background: #0a0a0a; border-top: 1px solid #222; padding: 64px 0; }
.section-kicker { color: #e23232; font-family: "Oswald", sans-serif; font-weight: 800; text-transform: uppercase; }
h2 { color: #fff; font-family: "Oswald", sans-serif; font-size: 2.6rem; margin: 0 0 26px; }
.dna-grid { display: grid; gap: 22px 32px; grid-template-columns: repeat(2, minmax(0, 1fr)); }
.dna-heading { align-items: center; color: #c8c8c8; display: flex; justify-content: space-between; margin-bottom: 9px; }
.dna-heading span { align-items: center; display: flex; gap: 8px; }
.dna-heading .v-icon { color: #f0b13c; }
.dna-heading strong { color: #fff; }
.dna-track { background: #252525; border-radius: 999px; height: 7px; overflow: hidden; }
.dna-track i { background: linear-gradient(90deg, #e23232, #f0b13c); display: block; height: 100%; }
@media (max-width: 700px) { .dna-grid { grid-template-columns: 1fr; } }
</style>
